import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { InventoryLocationXrefBus } from "./InventoryLocationXrefBus";
import { InventoryThresholdOverrideBus } from "./InventoryThresholdOverrideBus";
import { InventorySupplierXrefBus } from "./InventorySupplierXrefBus";
import { InventoryBus } from "./InventoryBus";
import { InventoryConsumablesBus } from "./InventoryConsumablesBus";
import { InventoryConsMatchesBus } from "./InventoryConsMatchesBus";
import { InventoryThresholdOverrideBranchBus } from "./InventoryThresholdOverrideBranchBus";
import { InventoryPartNbrsBus } from "./InventoryPartNbrsBus";

export class MonthDisplay extends BaseBus
{
    constructor(data: MonthDisplay) {
        super();
        if (data) {

            this.value = data.value;
            this.display = data.display;

        }
    }

    CID(): any {
        return this.value;
    }
    setId(id: any) {
        this.value = id;
    }
    initialize(data: MonthDisplay) {
        super.initialize(data);

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setBeforeSave() {
    }
    setCommon(userId: any, date: Date, companyId: any = null) {

    }

    display: string;
    value: string;

}
